import * as yup from 'yup';

import {TFunction} from 'i18next';

export const NAME_MAX_LENGTH = 50;
const NAME_MIN_LENGTH = 2;
export const EMAIL_MAX_LENGTH = 50;

const BillingDataValidationSchema = (
  t: TFunction,
  withSubscription?: boolean,
  cancellationPolicyLink?: boolean
) =>
  yup.object({
    name: yup
      .string()
      .min(
        NAME_MIN_LENGTH,
        t('validation:min_length', {
          name: t('name'),
          min: NAME_MIN_LENGTH
        }) || undefined
      )
      .max(
        NAME_MAX_LENGTH,
        t('validation:max_length', {
          name: t('name'),
          max: NAME_MAX_LENGTH
        }) || undefined
      )
      .required(
        t('validation:is_required', {
          name: t('name')
        }) || undefined
      ),
    address: yup.object().shape({
      street: yup.string().required(
        t('validation:is_required', {
          name: t('street')
        }) || undefined
      ),
      streetNumber: yup.string().required(
        t('validation:is_required', {
          name: t('street_number')
        }) || undefined
      ),
      postalCode: yup.string().required(
        t('validation:is_required', {
          name: t('postal_code')
        }) || undefined
      ),
      city: yup.string().required(
        t('validation:is_required', {
          name: t('city')
        }) || undefined
      ),
      country: yup.string().required(
        t('validation:is_required', {
          name: t('country')
        }) || undefined
      )
    }),
    email: yup
      .string()
      .email(t('validation:email_invalid') || undefined)
      .required(
        t('validation:is_required', {
          name: t('email')
        }) || undefined
      ),
    termsOfUseAccepted: yup
      .boolean()
      .required(t('validation:terms_of_participation_must_be_accepted'))

      .oneOf([true], t('validation:terms_of_participation_must_be_accepted')),
    ...(cancellationPolicyLink
      ? {
          cancellationPolicyAccepted: yup
            .boolean()
            .required(t('validation:cancellation_policy_must_be_accepted'))
            .oneOf([true], t('validation:cancellation_policy_must_be_accepted'))
        }
      : {}),
    ...(withSubscription
      ? {
          subscription: yup
            .string()
            .oneOf(['mh', 'wh', 'no'], t('validation:invalid_subscription'))
            .required(
              t('validation:is_required', {
                name: t('subscription_choice')
              })
            )
        }
      : {})
  });

export type UserSchemaData = yup.InferType<
  ReturnType<typeof BillingDataValidationSchema>
>;

export default BillingDataValidationSchema;
